export type SmsPurchaseStatus = "pending" | "paid" | "failed" | "cancelled";

export function purchaseStatusBadgeClass(status: string) {
  switch (status) {
    case "paid":
      return "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300";
    case "pending":
      return "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200";
    case "failed":
      return "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300";
    case "cancelled":
      return "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300";
    default:
      return "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300";
  }
}

export function purchaseStatusLabel(
  status: string,
  statusMessage?: string | null
): string {
  if (statusMessage?.trim()) return statusMessage.trim();

  switch (status) {
    case "paid":
      return "Payment successful";
    case "pending":
      return "Awaiting payment";
    case "failed":
      return "Payment failed";
    case "cancelled":
      return "Payment cancelled";
    default:
      return status;
  }
}
